import Applications from "./views/Applications";
import AppLanding from "./components/AppLanding";
import ApplicationTabs from "./components/ApplicationTabs";
import Payments from "./components/Payments";
import signup from "./components/SignUp";
import Auth from "../dashboard/modules/auth/middleware/Auth";
import ProfileComplete from "../dashboard/modules/auth/middleware/ProfileComplete";
import User from "../dashboard/modules/auth/middleware/User";
import MyApplications from "./components/MyApplications";
import appdocument from "./components/ApplicationDocument";
import Dashboard from "../dashboard/modules/dashboard/views/dashboardLayout.vue";
import Proforma from "./components/Proforma";
import Receipts from "./components/Receipt";
import ApplicationChecklist from "./components/ApplicationChecklist";

export default {
  appRoutes: [
    {
      path: "/applications",
      name: "Applications",
      component: Applications,
      children: [
        {
          path: "app-landing/:app?",
          name: "AppLanding",
          component: AppLanding,
        },
        {
          path: "checklist",
          name: "Checklist",
          component: ApplicationChecklist,
        },
        {
          path: "application",
          name: "ApplicationTabs",
          component: ApplicationTabs,
          meta: { middleware: [Auth, User] },
        },
        {
          path: "payments/:app",
          name: "Payments",
          component: Payments,
          meta: { middleware: [Auth] },
        },
        {
          path: "/signup/:prog",
          name: "Signup",
          component: signup,
        },
      ],
    },
  ],
  appDashboardRoutes: [
    {
      path: "/myapplications",
      component: Dashboard,
      children: [
        {
          path: "",
          name: "MyApplications",
          component: MyApplications,
          meta: { middleware: [Auth, ProfileComplete] },
        },
        {
          path: "/proforma/:appid",
          name: "Proforma",
          component: Proforma,
        },
        {
          path: "/receipt/:appid",
          name: "Receipts",
          component: Receipts,
        },
      ],
    },
  ],
  appDocumentRoutes: [
    {
      path: "/appdocument/:appid",
      component: Dashboard,
      children: [
        {
          path: "",
          name: "ApplicationDocument",
          component: appdocument,
        },
      ],
    },
  ],
};
